import {Link, useLocation} from 'react-router-dom';
import styles from './MenuLink.module.css';


export default function MenuLink( {to, state, children, onClick }) {
    const localizacao = useLocation();
    // SE houver um onClick (caso do Login), renderizamos um <button>
    if (onClick) {
        return (
            <button className={
                `${styles.link}
                 ${localizacao.pathname === to ? styles.linkDestacado : '' }`
                } onClick={onClick}
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
                {children}
            </button>
        );
    }

    return (
        <Link className={
                `${styles.link}
                 ${localizacao.pathname === to ? styles.linkDestacado : '' }`
                } to={ to } state={state}>
            {children}
        </Link>
    )

}